export { default } from './CategoriesInWardrobe'
